import { useState } from "react";
import Login from "../../pages/staticPages/Login";
import Navbar from "../staticView/globalComponents/Navbar";
import Footer from "../staticView/globalComponents/Footer";
import { useLocation } from "react-router-dom";
import TopBar from "../staticView/globalComponents/TopBar";
import GlobalLoader from "../utilities/preloader";
import api from "../../utils/api";

export default function LoginLayout() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref");

  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleGoogleLogin = () => {
    setIsRedirecting(true); // show loader

    const query = ref ? `?ref=${encodeURIComponent(ref)}` : "";
    window.location.href = `/auth/google${query}`;
  };

  return (
    <div className="w-full h-full relative">
      {/* Background page */}
      {!ref ? (
        <>
          <Navbar handleGoogleLogin={handleGoogleLogin} rel={ref} />
          <Login handleGoogleLogin={handleGoogleLogin} rel={ref} />
          <Footer />
        </>
      ) : (
        <>
          <TopBar />
          <Login handleGoogleLogin={handleGoogleLogin} rel={ref} />
          <Footer />
        </>
      )}

      {/* Loader Modal */}
      {isRedirecting && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <GlobalLoader />
        </div>
      )}
    </div>
  );
}
